import React, { useRef } from 'react'
import classNames from 'classnames'
import { formatUrl } from '../../utils/openForWork.utils'
import FontAwesome from 'react-fontawesome'
import { employerSide } from '../../routerHistory'
import moment from 'moment'
import { Dialog, DialogContent, IconButton } from '@material-ui/core'
import { ArrowBackIos, ArrowForwardIos } from '@material-ui/icons'
import { CloseIcon } from './closeIcon.component'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'

const PreviewOpenForWorkProfile = ({
  t,
  classes,
  // formValues,
  profile_pic,
  userData,
  portfolios = [],
  AreaOf_Expertise = [],
  role_title,
  short_des,
  inputCV,
  CV_file,
  linkRow = [],
  experienceInputRow = [],
  applicant_name,
  applicant_email,
  applicant_phone_no,
  applicant_address,
  applicant_zipcode,
  applicant_city,
  work_experience,
  ratingsSummary,
  ratingsByCompany,
  info_consent_allowed,
  previewAction,
  avg_rating_le,
  pinned_fav_lightentrepreneur
}) => {
  // const [viewPicture, setViewPicture] = React.useState(null)
  const [showAllExpertises, setShowAllExpertises] = React.useState(false)
  const visibleExpertises = showAllExpertises
    ? AreaOf_Expertise
    : AreaOf_Expertise?.slice(0, 3)
  return (
    <div className="row">
      {previewAction === 'openForWorkProfilePreview' && (
        <>
          <h4 style={{ textAlign: 'center' }}>{t('openForWork.title')}</h4>
          <br />
        </>
      )}
      <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
        <div className={classNames(classes.box)}>
          <div style={{ padding: '5px' }}>
            <div
              className="img-holder"
              style={{ position: 'relative', padding: '5px' }}
            >
              {' '}
              <img
                src={profile_pic || '../../../images/blank-profile-picture.png'}
                className="img-fluid img-thumbnail"
                style={{
                  aspectRatio: '3 / 3',
                  maxWidth: '150px'
                }}
              />
            </div>
            <div style={{ paddingInline: '9px' }}>
              <p>
                <b>
                  {userData
                    ? userData.firstname + ' ' + userData.lastname
                    : applicant_name}{' '}
                  {pinned_fav_lightentrepreneur ? (
                    <FontAwesome name="heart" style={{ color: '#F67131' }} />
                  ) : (
                    <FontAwesome name="heart-o" style={{ color: '#F67131' }} />
                  )}
                </b>
              </p>
              <p>{role_title}</p>
              {ratingsByCompany && avg_rating_le === undefined && (
                <p>
                  <FontAwesome name="star" style={{ color: '#ffd433' }} />{' '}
                  {ratingsSummary?.overall_average_rating} (
                  {ratingsSummary?.total_companies})
                </p>
              )}
              {avg_rating_le > 0 && (
                <p>
                  <FontAwesome name="star" style={{ color: '#ffd433' }} />{' '}
                  {avg_rating_le} ({ratingsByCompany?.length})
                </p>
              )}
            </div>
            <hr />
            <div style={{ paddingInline: '9px' }}>
              <p>{userData ? userData?.email : applicant_email}</p>
              {info_consent_allowed && (
                <>
                  <p>
                    {info_consent_allowed && userData
                      ? userData?.phone
                      : applicant_phone_no}
                  </p>
                  <p>
                    {info_consent_allowed && userData?.address
                      ? userData?.address
                      : applicant_address}
                  </p>
                  <p>
                    {info_consent_allowed && userData?.zip_code
                      ? userData?.zip_code
                      : applicant_zipcode}{' '}
                    {info_consent_allowed && userData?.city
                      ? userData?.city
                      : applicant_city}
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
        <br />
      </div>
      <div className="col-xs-12 col-sm-8 col-md-8 col-lg-8">
        <div className={classNames(classes.box)}>
          <div style={{ padding: '10px' }}>
            <p className={classNames(classes.previewLabel)}>
              {t('openForWork.des')}
            </p>
            <div
              dangerouslySetInnerHTML={{
                __html: short_des
              }}
            ></div>
            <div
              style={{
                display: 'flex',
                gap: '10px',
                marginTop: '10px',
                flexWrap: 'wrap',
                paddingBottom: '10px'
              }}
            >
              {' '}
              {visibleExpertises?.map((el, index) => (
                <div
                  key={index}
                  style={{
                    padding: '5px',
                    borderRadius: '8px',
                    textAlign: 'center',
                    backgroundColor: '#44c0cc',
                    color: '#FFFFFF'
                  }}
                >
                  {' '}
                  {t(
                    employerSide
                      ? `employer.areaOfExpertiseList.${el}`
                      : `areaOfExpertiseList.${el}`
                  )}
                </div>
              ))}
              {AreaOf_Expertise?.length > 3 && (
                <button
                  onClick={() => setShowAllExpertises(!showAllExpertises)}
                  style={{
                    marginTop: '10px',
                    background: 'none',
                    border: 'none',
                    color: '#007bff',
                    cursor: 'pointer',
                    textDecoration: 'underline'
                  }}
                >
                  {showAllExpertises
                    ? t('openForWork.seeLess')
                    : t('openForWork.seeMore')}
                </button>
              )}
            </div>
            <p className={classNames(classes.previewLabel)}>
              {t('openForWork.portfolio')}
            </p>
            {<PortfolioView portfolios={portfolios} />}
            <p className={classNames(classes.previewLabel)}>
              {t('openForWork.file2')}
            </p>
            <div style={{ marginRight: '10px' }}>
              <p>
                <a href={inputCV}>{CV_file ? CV_file : ''}</a>
              </p>
            </div>
            {linkRow?.map((el, index) => (
              <div key={index}>
                <p className={classNames(classes.previewLabel)}>
                  {el.link_title}
                </p>
                <div style={{ marginRight: '10px', wordWrap: 'break-word' }}>
                  <p>
                    {' '}
                    <a href={formatUrl(el.link_url)} target="blank">
                      {el.link_url}
                    </a>
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <br />
        <div className={classNames(classes.box)}>
          <div style={{ padding: '10px' }}>
            <p className={classNames(classes.previewLabel)}>
              {t('openForWork.label15')}
            </p>
            {experienceInputRow?.length > 0 &&
              experienceInputRow[0].CompanyName !== null &&
              experienceInputRow.map((el, index) => (
                <div key={index}>
                  <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                      <p>{el.JobTitle}</p>
                      <p>{el.CompanyName}</p>
                      {!el?.StartDate ? (
                        <p>
                          {el.start_month}.{el.start_year}-{el.end_month}.
                          {el.end_year}
                        </p>
                      ) : (
                        <p>
                          {moment(el.StartDate).format('MM.YYYY')}-
                          {moment(el.EndDate).format('MM.YYYY')}
                        </p>
                      )}
                      <p>{el.Location}</p>
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-5 col-lg-5">
                      <p>{t('openForWork.p1')}</p>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: el.Responsibilities
                        }}
                      ></div>
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                      <p>{t('openForWork.p2')}</p>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: el.KeyAchievements
                        }}
                      ></div>
                    </div>
                  </div>
                  <hr />
                </div>
              ))}
            <div
              dangerouslySetInnerHTML={{
                __html: work_experience
              }}
            ></div>
          </div>
        </div>
        <br />
        {ratingsByCompany && (
          <div className={classNames(classes.box)}>
            <div style={{ padding: '5px' }}>
              <p className={classNames(classes.previewLabel)}>
                {t('openForWork.label16')}
              </p>
              <div>
                {ratingsByCompany?.map((el, index) => (
                  <div key={index}>
                    <p>
                      <span style={{ paddingRight: '25px' }}>
                        {el.company_name}{' '}
                      </span>
                      <FontAwesome name="star" style={{ color: '#ffd433' }} />{' '}
                      {el.average_rating || el.avg_entrepreneurs_rating}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

function PortfolioView({ portfolios }) {
  const [currentIndex, setCurrentIndex] = React.useState(null)
  const handleClose = () => {
    setCurrentIndex(null)
  }
  const handlePrev = () => {
    setCurrentIndex((prev) => (prev > 0 ? prev - 1 : prev))
  }
  const handleNext = () => {
    setCurrentIndex((prev) => (prev < portfolios.length - 1 ? prev + 1 : prev))
  }
  const currentImage =
    currentIndex !== null
      ? portfolios[currentIndex]?.FilePath || portfolios[currentIndex]?.data
      : null

  return (
    <div>
      <ImageScroller images={portfolios} setCurrentIndex={setCurrentIndex} />
      <Dialog
        open={currentIndex !== null}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
      >
        <CloseIcon fontSize="large" onClick={() => setCurrentIndex(null)} />
        <DialogContent style={{ position: 'relative' }}>
          <IconButton
            onClick={handlePrev}
            disabled={currentIndex === 0}
            style={{
              position: 'absolute',
              left: 0,
              top: '50%',
              transform: 'translateY(-50%)',
              zIndex: 2,
              color: currentIndex === 0 ? '' : '#F67131'
            }}
          >
            <ArrowBackIos fontSize="large" />
          </IconButton>
          <img
            src={currentImage}
            alt="preview"
            style={{
              width: '100%',
              height: 'auto',
              objectFit: 'contain',
              borderRadius: '5px',
              padding: '10px'
            }}
          />
          <IconButton
            onClick={handleNext}
            disabled={currentIndex === portfolios.length - 1}
            style={{
              position: 'absolute',
              right: 0,
              top: '50%',
              transform: 'translateY(-50%)',
              zIndex: 2,
              color: currentIndex === portfolios.length - 1 ? '' : '#F67131'
            }}
          >
            <ArrowForwardIos fontSize="large" />
          </IconButton>
        </DialogContent>
      </Dialog>
    </div>
  )
}

const ImageScroller = ({ images, setCurrentIndex }) => {
  const scrollContainerRef = useRef(null)

  const scroll = (direction) => {
    const container = scrollContainerRef.current
    const scrollAmount = 300 // pixels to scroll per click
    if (container) {
      container.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      })
    }
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <button
        onClick={() => scroll('left')}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: '#F67131'
        }}
      >
        <ChevronLeft fontSize="large" />
      </button>
      <div
        ref={scrollContainerRef}
        style={{
          display: 'flex',
          overflowX: 'auto',
          scrollBehavior: 'smooth',
          gap: '8px',
          padding: '8px',
          width: '500px'
        }}
      >
        {images.map((file, index) => {
          const previewUrl = file?.FilePath ? file?.FilePath : file?.data
          return (
            <img
              key={index}
              src={previewUrl}
              alt={`Image ${index}`}
              style={{
                width: '150px',
                height: '100px',
                objectFit: 'cover',
                borderRadius: '8px'
              }}
              onClick={() => setCurrentIndex(index)}
            />
          )
        })}
      </div>
      <button
        onClick={() => scroll('right')}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: '#F67131'
        }}
      >
        <ChevronRight fontSize="large" />
      </button>
    </div>
  )
}

export default PreviewOpenForWorkProfile
